export default "__VITE_ASSET__CiO_GuWw__"